import {Event} from 'shared/events/Event';
import {useJobContext} from 'contexts/JobContext';
import {PartialJob} from 'shared/types/PartialJob';
import {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {useIsConfirmationPage} from 'components/customer/Confirmation/helpers/useIsConfirmationPage';
import {useAppContext} from 'contexts/ApplicationContext';
import {JOB_STATUS} from 'components/customer/Dashboard/LastJobButton';

export const useGoToJobConfirmationPage = (): Event => {
    const {userProfile} = useAppContext();
    const navigate = useNavigate();
    const {job} = useJobContext() as PartialJob;
    const {isConfirmationPage} = useIsConfirmationPage();

    const action = useCallback((): Promise<boolean> => {
        return new Promise((resolve) => {
            if (isConfirmationPage) {
                resolve(true);
                return;
            }

            if (
                !userProfile?.jobConfirmationEnabled ||
                (userProfile.jobConfirmationEnabled &&
                    job.status != JOB_STATUS.PROCESSING)
            ) {
                resolve(true);
                return;
            }

            void navigate(`/v2/job/${job.displayId}/confirmation`);
            resolve(false);
        });
    }, [job, navigate, isConfirmationPage, userProfile]);

    return {
        action,
    };
};
